// /sign-on-phone — the page a phone opens from the QR code of "sign with your
// phone" (no login; /bg/sign-on-phone the same in Bulgarian)
import { lazyRoute } from "aldoo-ra/Router/lazy-route"

export default {
  "/sign-on-phone": lazyRoute(() => import("./SignOnPhone")),
}
